import React from "react";
import type { ContributingFactor } from "../../../../components/RCA/types";

interface RCAContributingFactorsSectionProps {
  factors: ContributingFactor[];
  onChange: (factors: ContributingFactor[]) => void;
  readOnly: boolean;
}

const RCAContributingFactorsSection: React.FC<RCAContributingFactorsSectionProps> = ({
  factors,
  onChange,
  readOnly,
}) => {
  const handleApplicableChange = (index: number, isApplicable: boolean) => {
    const updated = [...factors];
    updated[index] = { ...updated[index], isApplicable };
    onChange(updated);
  };

  const handleObservationChange = (index: number, observation: string) => {
    const updated = [...factors];
    updated[index] = { ...updated[index], observation };
    onChange(updated);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">
        H. Possible Reasons - Contributing Factors For Fire Incident
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Sr. No</th>
              <th className="border p-2">Contributing Factors</th>
              <th className="border p-2">Applicable</th>
              <th className="border p-2">Incident Area Observation</th>
            </tr>
          </thead>
          <tbody>
            {factors.map((factor, index) => (
              <tr key={index}>
                <td className="border p-2">{factor.srNo}</td>
                <td className="border p-2">{factor.factor}</td>
                <td className="border p-2 text-center">
                  <select
                    value={factor.isApplicable ? "Yes" : "No"}
                    onChange={(e) =>
                      handleApplicableChange(index, e.target.value === "Yes")
                    }
                    className="w-full p-1 border rounded"
                    disabled={readOnly}
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </td>
                <td className="border p-2">
                  <textarea
                    value={factor.observation}
                    onChange={(e) =>
                      handleObservationChange(index, e.target.value)
                    }
                    className={`w-full p-1 border rounded ${
                      factor.isApplicable && !factor.observation?.trim()
                        ? "border-red-500"
                        : ""
                    }`}
                    rows={2}
                    readOnly={readOnly}
                    required={factor.isApplicable}
                  />
                  {factor.isApplicable && !factor.observation?.trim() && (
                    <p className="text-xs text-red-500 mt-1">
                      Observation is required when Yes is selected.
                    </p>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RCAContributingFactorsSection;
